import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const VisibleColumn = iotsUtils.fromList(constants.report.designTransactions.VisibleColumns);
